<template>
  <div class="newsletter-brandlogo-area section-padding-xs">
    <div class="container">
      <div class="row no-gutters align-items-center">

        <!-- Newsletter -->
        <div class="col-lg-4">
          <div class="newsletterbox">
            <h5>SIGN UP FOR OUR WEEKLY NEWSLETTER !</h5>
            <form action="#">
              <input type="text" placeholder="Email" v-model="submailbox.email">
              <button type="button" @click="submitSubscribe()">Subscribe</button>
            </form>

          </div>
        </div>
        <!--// Newsletter -->

        <!-- Brand Logo -->
        <div class="col-lg-8">
          <div class="brand-logos slider-navigation-2">
            <div class="brand-logo" v-for="item in brandLogoDatas">
              <a href="#">
                <img :src="item.pic" :alt="item.name">
              </a>
            </div>
          </div>
        </div>
        <!--// Brand Logo -->

      </div>
    </div>
  </div>
</template>

<script>
    import request from '@/utils/request'
    import {getLAdvertise} from '@/api/advertise'
    export default {
        name: "newsletter",
        data(){
          return {
            brandLogoDatas:[],
            submailbox:{
              email:""
            }
          }
        },
        methods:{
          submitSubscribe(){
            request({
              url:'/submailbox/create',
              method:'POST',
              data:this.submailbox
            }).then(res=>{
                console.log(res)
            })
          }
        },
        beforeCreate(){
        let _this = this
        getLAdvertise(4).then(res=>{
          if(res.data.code===200) {
            _this.brandLogoDatas = res.data.data

            setTimeout(function(){

              /* Brand Logo Slider Active */
              $('.brand-logos').slick({
                slidesToShow: 4,
                autoplay: true,
                autoplaySpeed: 5000,
                dots: false,
                arrows: true,
                easing: 'ease-in-out',
                prevArrow: '<span class="slider-navigation slider-navigation-prev"><i class="fa fa-caret-left"></i></span>',
                nextArrow: '<span class="slider-navigation slider-navigation-next"><i class="fa fa-caret-right"></i></span>',
                responsive: [{
                  breakpoint: 992,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                  }
                },
                  {
                    breakpoint: 768,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 1
                    }
                  },
                  {
                    breakpoint: 450,
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                  }]
              });
            },200)
          }
        })
      }
    }
</script>

<style scoped>

</style>
